import React from 'react';
import {connect} from 'react-redux';
import {BaseLineupPlayersComponent} from 'components/organisms/lineup/components/mobile/lineup-players/sports/mma';
import {toFloat} from 'helpers/number-helper';

class LineupPlayersComponent extends BaseLineupPlayersComponent {
    getPlayerView(player) {
        const rowClassName = this.getRowClassName(player);

        return (
            <tr key={player.playerId} className={rowClassName}>
                <td>
                    <strong>{player.name}</strong>
                </td>
                <td>{player.positionInLineup}</td>
                <td>
                    <strong className="text-gray">{player.getPropValueOfLineupRole('salary')}</strong>/
                    {toFloat(player.lineupPoints, 3)}
                </td>
            </tr>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
        filterLineupsByPlayer,
    } = state;

    return {
        lineups,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
